var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelPink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5625 4.5H15.125V3.875C15.125 2.84113 14.2839 2 13.25 2H10.75C9.71613 2 8.875 2.84113 8.875 3.875V4.5H5.4375C4.57594 4.5 3.875 5.20094 3.875 6.0625V8.25C3.875 8.59516 4.15484 8.875 4.5 8.875H4.84156L5.38152 20.2142C5.42922 21.2156 6.25187 22 7.25437 22H16.7456C17.7482 22 18.5708 21.2156 18.6185 20.2142L19.1584 8.875H19.5C19.8452 8.875 20.125 8.59516 20.125 8.25V6.0625C20.125 5.20094 19.4241 4.5 18.5625 4.5ZM10.125 3.875C10.125 3.53039 10.4054 3.25 10.75 3.25H13.25C13.5946 3.25 13.875 3.53039 13.875 3.875V4.5H10.125V3.875ZM5.125 6.0625C5.125 5.8902 5.2652 5.75 5.4375 5.75H18.5625C18.7348 5.75 18.875 5.8902 18.875 6.0625V7.625C18.6824 7.625 5.92316 7.625 5.125 7.625V6.0625ZM17.3699 20.1547C17.354 20.4885 17.0798 20.75 16.7456 20.75H7.25437C6.9202 20.75 6.64598 20.4885 6.63012 20.1547L6.09297 8.875H17.907L17.3699 20.1547Z",
    fill: "#A93E71"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 19.5C12.3452 19.5 12.625 19.2202 12.625 18.875V10.75C12.625 10.4048 12.3452 10.125 12 10.125C11.6548 10.125 11.375 10.4048 11.375 10.75V18.875C11.375 19.2202 11.6548 19.5 12 19.5Z",
    fill: "#A93E71"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.125 19.5C15.4702 19.5 15.75 19.2202 15.75 18.875V10.75C15.75 10.4048 15.4702 10.125 15.125 10.125C14.7798 10.125 14.5 10.4048 14.5 10.75V18.875C14.5 19.2202 14.7798 19.5 15.125 19.5Z",
    fill: "#A93E71"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.875 19.5C9.22016 19.5 9.5 19.2202 9.5 18.875V10.75C9.5 10.4048 9.22016 10.125 8.875 10.125C8.52984 10.125 8.25 10.4048 8.25 10.75V18.875C8.25 19.2202 8.5298 19.5 8.875 19.5Z",
    fill: "#A93E71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelPink);
export default __webpack_public_path__ + "static/media/del-pink.3d6fbf6abc6115ad6e3578caea7ba777.svg";
export { ForwardRef as ReactComponent };